import { render, staticRenderFns } from "./BatchManage.vue?vue&type=template&id=8a7f1f04&scoped=true"
import script from "./BatchManage.vue?vue&type=script&lang=js"
export * from "./BatchManage.vue?vue&type=script&lang=js"
import style0 from "./BatchManage.vue?vue&type=style&index=0&id=8a7f1f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f1f04",
  null
  
)

export default component.exports